import { X } from "lucide-react";
import React from "react";

import {
  IgAutocomplete,
  IgCheckbox,
  IgTextField,
  IgTooltip,
  IgTypographyTooltip,
} from "@intelligems/ig-theme";
import { Grid, MenuItem } from "@mui/material";

interface ProductFilterItemProps {
  name: string;
  selected: string | undefined;
  onToggleSelected: (name: string) => void;
  items: {
    label: string;
    value: string;
  }[];
  onChange: (value: string[]) => void;
  selectedValues: string[];
  disabled?: boolean;
}

export const ProductFilterItem = ({
  name,
  selected,
  onToggleSelected,
  items,
  selectedValues,
  onChange,
  disabled,
}: ProductFilterItemProps) => {
  if (!items?.length) return null;
  return (
    <IgTooltip
      title={
        disabled
          ? `${name} filtering is not compatible with ${name === "Tags" ? "collection" : "tag"} filtering, remove your ${name === "Tags" ? "collection" : "tag"} filters`
          : ""
      }
    >
      <IgAutocomplete
        disabled={disabled}
        multiple
        ListboxProps={{
          sx: {
            maxHeight: "200px",
          },
        }}
        disableCloseOnSelect={true}
        value={selectedValues}
        options={items}
        onChange={(_, newValue) => {
          const flattened = newValue
            .flat()
            .map((item) => (typeof item === "string" ? item : item.value));
          onChange(flattened);
        }}
        isOptionEqualToValue={(option, value: string[]) => {
          return value.includes(option.value);
        }}
        getOptionLabel={(option) => {
          return `${option.label}`;
        }}
        renderInput={(params) => (
          <IgTextField
            {...params}
            placeholder={
              selectedValues.length > 0
                ? `${name} (+${selectedValues.length})`
                : `${name}`
            }
          />
        )}
        disablePortal={true}
        renderTags={() => null}
        clearIcon={<X size={16} />}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <MenuItem
              key={`${key}-${props.id}`}
              {...optionProps}
              sx={{ height: "32px", paddingLeft: 1 }}
            >
              <Grid
                container
                direction={"row"}
                columnSpacing={1}
                alignItems={"center"}
              >
                <Grid item>
                  <IgCheckbox size={"small"} checked={selected} />
                </Grid>
                <Grid
                  item
                  sx={{
                    maxWidth: "100px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  <IgTypographyTooltip
                    variant={"body1"}
                    textMaxWidth={"120px"}
                    text={option.label}
                    noHover={true}
                    textSx={{ fontWeight: 400 }}
                  />
                </Grid>
              </Grid>
            </MenuItem>
          );
        }}
        fullWidth={true}
      />
    </IgTooltip>
  );
};
